/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

    {
        id      : 'dashboardGroup',
        title   : 'Dashboard',
        subtitle: '',
        type    : 'group',
        icon    : '',
        children: [
            {
                id   : 'dashboard',
                title: 'Dashboard',
                icon : 'heroicons_outline:home',
                type : 'basic',
                link : '/dashboard',
            },
            {
                id   : 'ai-travel',
                title: 'AI Travel',
                icon : 'heroicons_outline:chat-bubble-oval-left-ellipsis',
                type : 'basic',
                link : '/ai-travel',
                disabled: false
            },
            {
                id: 'app.trips',
                title: 'Quotes',
                type: 'collapsable',
                icon: 'heroicons_outline:square-3-stack-3d',
                children: [
                    {
                        id: 'app.trips.requests',
                        title: 'All',
                        type: 'basic',
                        link: '/app/trips/requests',
                    },
                    {
                        id: 'app.trips.upcoming',
                        title: 'Upcoming',
                        type: 'basic',
                        link: '/app/trips/upcoming',
                        disabled: true,
                        hidden: () => true,
                    },
                    {
                        id: 'app.trips,returning',
                        title: 'Returning',
                        type: 'basic',
                        link: '/app/trips/returning',
                        disabled: true,
                        hidden: () => true,
                    },
                    {
                        id: 'app.trips.completed',
                        title: 'Completed',
                        type: 'basic',
                        link: '/app/trips/completed',
                    },
                ],
            },
            // {
            //     id   : 'tasks',
            //     title: 'Tasks',
            //     type : 'basic',
            //     icon : 'heroicons_outline:check-circle',
            //     link : '/app/tasks',
            // }
        ],
    },

    {
        id      : 'destinations',
        title   : 'Trips',
        subtitle: 'Browse, plan, create & share',
        type    : 'group',
        icon    : '',
        children: [
            {
                id   : 'packages',
                title: 'Packages',
                type : 'basic',
                icon : 'mat_outline:explore',
                link : '/quote/packages/popular',
                disabled: false
            },
            {
                id   : 'flights',
                title: 'Flights',
                type : 'basic',
                icon : 'mat_outline:flight_takeoff',
                link : '/quote/flights',
                disabled: false
            },
            {
                id   : 'accommodation',
                title: 'Accommodation',
                type : 'basic', //'collapsable',
                icon : 'heroicons_outline:home-modern',
                link : '/quote/stays',
                disabled: false
                // children: [
                //     {
                //         id   : 'resources',
                //         title: 'Setup',
                //         type : 'basic',
                //         icon : 'heroicons_outline:squares-2x2',
                //         link : '/resources',
                //         disabled: true
                //     }
                // ]
            },
            {
                id   : 'cars',
                title: 'Cars',
                type : 'basic',
                icon : 'mat_outline:directions_car',
                link : '/quote/cars',
                disabled: true
            },
            {
                id   : 'transfers',
                title: 'Transfers',
                type : 'basic',
                icon : 'mat_outline:airport_shuttle',
                link : '/quote/transfers',
                disabled: true
            },
            {
                id   : 'activities',
                title: 'Activities',
                type : 'basic',
                icon : 'mat_outline:beach_access',
                link : 'quote/activities',
                disabled: true
            },
            {
                id   : 'cruises',
                title: 'Cruises',
                type : 'basic',
                icon : 'mat_outline:directions_boat',
                link : 'quote/cruises/cruise-search',
                disabled: true
            },
        ],
    },

    {
        id      : 'metrics',
        title   : 'Metrics',
        subtitle: '',
        type    : 'group',
        icon    : '',
        children: [
            {
                id   : 'dashboard.travel',
                title: 'Travel Insights',
                type : 'basic',
                icon : 'heroicons_outline:chart-bar',
                link : '/dashboards/travel',
            },
            {
                id   : 'dashboard.client-trips',
                title: 'Client Trips',
                type : 'basic',
                icon : 'heroicons_outline:calendar-days',
                link : '/dashboards/client-trips',
            },
            {
                id   : 'dashboard.commission',
                title: 'Agent Commissions',
                type : 'basic',
                icon : 'heroicons_outline:currency-dollar',
                link : '/dashboards/commission',
            },
            {
                id   : 'dashboard.product-performance',
                title: 'Product Performance',
                type : 'basic',
                icon : 'heroicons_outline:chart-pie',
                link : '/dashboards/product-performance',
            },
            {
                id   : 'dashboard.suppliers',
                title: 'Suppliers',
                type : 'basic',
                icon : 'heroicons_outline:building-storefront',
                link : '/dashboards/suppliers',
            },
        ],
    },

    {
        id      : 'resources',
        title   : 'Resources',
        subtitle: '',
        type    : 'group',
        icon    : '',
        children: [
            {
                id   : 'report',
                title: 'Reports',
                type : 'basic',
                icon : 'feather:activity',
                link : '/reports',
                disabled: false
            },
            {
                id   : 'setup',
                title: 'Setup',
                type : 'basic',
                icon : 'heroicons_outline:squares-2x2',
                link : '/resources',
                disabled: false
            },
            {
                id   : 'settings',
                title: 'Settings',
                type : 'basic',
                icon : 'feather:settings',
                link : '/settings',
                disabled: true
            },
            {
                id   : 'help-center',
                title: 'Help Center',
                type : 'basic',
                icon : 'heroicons_outline:information-circle',
                link : '/help-center',
                disabled: false
            },
        ],
    },

    {
        id      : 'changelog',
        title   : '',
        subtitle: '',
        type    : 'group',
        icon    : '',
        children: [ 
            {
                id   : 'changelog',
                title: 'Changelog',
                type : 'basic',
                icon : 'heroicons_outline:check-circle',
                link : '/changelog',
                disabled: false
            }
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Overview',
        tooltip : 'Overview',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'destinations',
        title   : 'Trips',
        tooltip : 'Destinations',
        subtitle: 'Browse, plan, create & share',
        type    : 'aside',
        icon    : 'heroicons_outline:stop',
        children: [
            {
                id   : 'destinations',
                title: 'Packages',
                type : 'aside',
                icon : 'mat_outline:explore',
                link : '/quote/packages',
            },
            {
                id   : 'destinations',
                title: 'Flights',
                type : 'aside',
                icon : 'mat_outline:flight_takeoff',
                link : '/quote/flights'
            },
            {
                id   : 'destinations',
                title: 'Stays',
                type : 'basic',
                icon : 'heroicons_outline:home-modern',
                link : '/quote/stays'
            },
            {
                id   : 'destinations',
                title: 'Cars',
                type : 'basic',
                icon : 'mat_outline:directions_car',
                link : '/quote/cars'
            },
            {
                id   : 'destinations',
                title: 'Activities',
                type : 'basic',
                icon : 'beach_access',
                link : 'quote/activities'
            },
            {
                id   : 'destinations',
                title: 'Cruises',
                type : 'basic',
                icon : 'mat_outline:directions_boat',
                link : 'quote/cruises'
            }
        ],
    },
];

export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;

export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
